import React, { useContext, useMemo } from 'react';
import { useLaundryBookings } from 'services/laundry/bookings';
import { FormattedMessage, useIntl } from 'react-intl';
import Loader from 'components/loaders/Loader';
import { formatResourceName } from 'utils/formatResourceName';
import { ShouldRender } from 'components/ShouldRender';
import { LaundryBrikkModalContext } from '../../../LaundryBrikkModalContext';
import { BookingCard } from './components/BookingCard';
import styles from './styles.module.scss';

export function BookingsAndRemindersSection({ laundryResources }) {
  const intl = useIntl();
  const { selectedResource } = useContext(LaundryBrikkModalContext);
  const { laundryBookings, isFetching } = useLaundryBookings(
    selectedResource && selectedResource.id,
  );

  const { futureBookings, pastBookings } = useMemo(() => {
    if (!laundryBookings) return { futureBookings: [], pastBookings: [] };

    const now = new Date();
    const future = [];
    const past = [];

    laundryBookings.forEach((booking) => {

      const endTime = booking.to ? parseInt(booking.to.split('.')[0], 10) : 0;
      const endDate = booking && booking?.fullEndDate && new Date(booking.fullEndDate).setHours(endTime);

      const isPastBooking = endDate < now;

      if (isPastBooking) {
        past.push(booking);
      } else {
        future.push(booking);
      }
    });

    future.sort((a, b) => new Date(b.fullDate) - new Date(a.fullDate));
    past.sort((a, b) => new Date(b.fullDate) - new Date(a.fullDate));

    return { futureBookings: future, pastBookings: past };
  }, [laundryBookings]);

  if (isFetching) return <Loader />;

  const renderBookingCard = (booking, isPast = false) => {
    const resource = laundryResources.find(
      (resource) => resource && resource.id === (booking && booking.resourceId),
    );

    return (
      <BookingCard
        key={booking.id}
        bookingId={booking.id}
        fullDate={booking && booking.fullDate}
        address={resource && resource.address}
        name={formatResourceName(resource && resource.name, intl.locale)}
        icon={resource && resource.icon}
        from={selectedResource?.type === 'apartment' ? '11.00' : booking && booking.from}
        to={selectedResource?.type === 'apartment' ? '11.00' : booking && booking.to}
        fullEndDate={booking && booking.fullEndDate}
        showRange={booking && booking.fullEndDate}
        isPast={isPast}
      />
    );
  };

  return (
    <div className={styles.cardsSectionWrapper}>
      {futureBookings.map((booking) => renderBookingCard(booking, false))}

      <ShouldRender condition={pastBookings.length > 0 && futureBookings.length > 0}>
        <div className={styles.separator}>
          <span className={styles.separatorText}>
            <FormattedMessage id="pastBookings" />
          </span>
        </div>
      </ShouldRender>

      <ShouldRender condition={pastBookings.length > 0 && futureBookings.length === 0}>
        <div className={styles.separator}>
          <span className={styles.separatorText}>
            <FormattedMessage id="pastBookings" />
          </span>
        </div>
      </ShouldRender>

      {pastBookings.map((booking) => renderBookingCard(booking, true))}

      <ShouldRender condition={pastBookings.length === 0 && futureBookings.length === 0}>
        <p className={styles.noBookingsFound}>
          <FormattedMessage id="noBookingsFound" />
        </p>
      </ShouldRender>
    </div>
  );
}
